module.exports = __webpack_public_path__ + "static/media/21_Sept_2022_National_CSR_Leadership_Award.65864c1a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/21_Sept_2022_National_CSR_Leadership_Award.webp
// module id = 301
// module chunks = 0